import { useMemo } from "react";

import type {
  ClinicalCrmSectionsBoardModel,
  ClinicalCrmSectionsContentModel,
} from "../types";
import { useClinicalCrmSectionsLayout } from "./useClinicalCrmSectionsLayout";

export function useClinicalCrmSectionsBoardModel(
  content: ClinicalCrmSectionsContentModel,
): ClinicalCrmSectionsBoardModel {
  const layout = useClinicalCrmSectionsLayout();

  const contentModel = useMemo(() => content, [content]);

  return {
    layout,
    content: contentModel,
  };
}
